export const cellPhonePolicy = (date?: string) => {
  return [
    { text: 'Commercial Motor Vehicle (CMV) Cell Phone Policy', style: 'h1' },

    { text: 'The company Sierra Expediting Inc wants to ensure the safety of its drivers and the motoring public. Distracted driving has a profound impact on your ability to safely operate a vehicle. The company strongly encourages drivers to not use mobile communication devices while driving. If it becomes absolutely necessary to make or receive a call while operating a commercial motor vehicle (CMV), mobile phone use (with either a personal or company-issued phone) by company employees shall be subject to the following restrictions:', style: 'p' },

    { text: '1) The mobile communications device must have a hands-free method of operation. This can include, but is not limited to:', style: 'p', margin: [20, 0, 0, 0] },
    { text: 'a. Bluetooth headset;', style: 'p', margin: [40, 0, 0, 0] },
    { text: 'b. a vehicle-integrated communication system; or', style: 'p', margin: [40, 0, 0, 0] },
    { text: 'c. a mobile hands-free speaker/microphone device.', style: 'p', margin: [40, 0, 0, 0] },

    { text: '2) Before commencing travel, the mobile phone must be configured so that it can receive and make a call either through voice activation or with the push of a single button.', style: 'p', margin: [20, 0, 0, 0] },

    { text: '3) The mobile phone must be located either on the driver or within easy reach (i.e. affixed to the dash, visor, driver’s-side seat, etc.)', style: 'p', margin: [20, 0, 0, 0] },

    { text: '4) If the phone is going to be used as a GPS device to provide travel or mapping directions, it must be set up and running before commencing travel.', style: 'p', margin: [20, 0, 0, 0] },

    { text: 'Unless the driver pulls off the road and parks in a safe location, drivers are prohibited from:', style: 'p' },

    { text: '1) Sending or reading text messages or photos;', style: 'p', margin: [20, 0, 0, 0] },
    { text: '2) Taking or viewing photos;', style: 'p', margin: [20, 0, 0, 0] },
    { text: '3) Manually dialing a phone number;', style: 'p', margin: [20, 0, 0, 0] },
    { text: '4) Looking up a contact number in the phone’s directory;', style: 'p', margin: [20, 0, 0, 0] },
    { text: '5) Manipulating the GPS phone function in any way; or', style: 'p', margin: [20, 0, 0, 0] },
    { text: '6) Browsing the internet or using any other phone application beyond taking and receiving calls.', style: 'p', margin: [20, 0, 0, 0] },

    { text: 'If a driver pulls off the road and parks in a safe location to engage in any of these mobile-phone related activities, they must note it in their travel log. In the case of making a phone call, the driver may commence driving again while they are still on the call as long as a hands-free device is used.', style: 'p' },

    { text: 'Disciplinary actions may range from $50 for a first offense to $200 for chronic offenders.', style: 'p', bold: true, alignment: 'center' },

    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 200,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
        {
          type: 'line',
          x1: 500,
          y1: 0,
          x2: 350,
          y2: 0,
          lineWidth: 1,
          lineColor: 'black',
        },
      ],
      style: 'input',
      margin: [0, 40, 0, 0]
    },

    { text: "Driver's Signature", style: 'label', margin: [0, 2, 0, 0] },
    { text: `${date}`, margin: [350, -32, 0, 0] },
    { text: "Date", style: 'label', margin: [350, 5, 0, 0] },

    { text: '', pageBreak: 'before' },
  ];
};